import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { GENERAL_CONTACT_INFO, IS_MOBILE, LOCALIZED_CONTACT_INFO } from 'src/consts';

import type { PropsFromRedux } from '.';

interface RendererProps
  extends PropsFromRedux,
    PropsWithChildren<{
      preferredLocation?: string;
      className: string;
      generalContactNumber?: boolean;
      phoneNumber?: string;
    }> {}

export const Renderer = ({
  preferredLocation,
  className,
  children,
  dispatchSegmentTrack,
  onResetChat,
  currentLocation,
  previousLocation,
  isChatOpen,
  generalContactNumber,
  phoneNumber,
}: RendererProps) => {
  const getPhoneNumber = () => {
    if (phoneNumber) {
      return phoneNumber;
    }
    if (generalContactNumber) {
      return GENERAL_CONTACT_INFO.CAPSULE_TEXT_NUMBER;
    }
    if (preferredLocation && LOCALIZED_CONTACT_INFO.CAPSULE_TEXT_NUMBER[preferredLocation]) {
      return LOCALIZED_CONTACT_INFO.CAPSULE_TEXT_NUMBER[preferredLocation];
    }
    return GENERAL_CONTACT_INFO.CAPSULE_TEXT_NUMBER;
  };

  const smsLocation = `sms:${getPhoneNumber()}`;
  const handleClick = () => {
    dispatchSegmentTrack(UNIFIED.contactUsCallOrText, { openedFrom: currentLocation });
  };

  useEffect(() => {
    if (IS_MOBILE && isChatOpen) {
      //We set a timeout so the user can process they are on the logged in page before we switch them to the chat window
      setTimeout(() => {
        window.location = smsLocation;
        dispatchSegmentTrack(UNIFIED.contactUsCallOrText, { openedFrom: previousLocation });
        onResetChat();
      }, 1000);
    }
  }, [dispatchSegmentTrack, onResetChat, isChatOpen, previousLocation, smsLocation]);

  return (
    <a className={className} aria-label={'Text Us'} href={smsLocation} onClick={handleClick} data-cy="phone-link">
      {children}
    </a>
  );
};
